import { InfoCustomerViewModel } from 'app/shared/prothesis-customer-api-view-models/info-customer.view-model';
import { ReadAllowedCustomerViewModel } from 'app/shared/prothesis-customer-api-view-models/read-allowed-customer.view-model';
import { CustomerTenantModel } from '../models/customer-tenant-model';

export class CustomerTenantModelHelper {
  public static fromInfoCustomerViewModel(viewModels: InfoCustomerViewModel[]): Array<CustomerTenantModel> {
    const models = new Array<CustomerTenantModel>();
    viewModels.forEach((viewModel) => {
      const model = this._createModelFromInfoCustomerViewModel(viewModel);
      models.push(model);
    });

    return models;
  }

  public static fromInfoCustomerViewModelSingle(viewModel: InfoCustomerViewModel): CustomerTenantModel {
    return this._createModelFromInfoCustomerViewModel(viewModel);
  }

  public static fromReadAllowedCustomerViewModel(viewModels: ReadAllowedCustomerViewModel[]): Array<CustomerTenantModel> {
    const models = new Array<CustomerTenantModel>();
    viewModels.forEach((viewModel) => {
      const model = this._createModelFromReadAllowedCustomerViewModel(viewModel);
      models.push(model);
    });

    return models;
  }

  public static fromReadAllowedCustomerViewModelSingle(viewModel: ReadAllowedCustomerViewModel): CustomerTenantModel {
    return this._createModelFromReadAllowedCustomerViewModel(viewModel);
  }

  private static _createModelFromInfoCustomerViewModel(infoCustomerViewModel: InfoCustomerViewModel): CustomerTenantModel {
    const customerTenant = new CustomerTenantModel();
    customerTenant.code = infoCustomerViewModel.code;
    customerTenant.customerGroupFlag = infoCustomerViewModel.customerGroupFlag;
    customerTenant.customerGroupName = infoCustomerViewModel.customerGroupName;
    customerTenant.laboratoryName = infoCustomerViewModel.laboratoryName;
    customerTenant.name = infoCustomerViewModel.name;
    customerTenant.uuid = infoCustomerViewModel.uuid;
    return customerTenant;
  }

  private static _createModelFromReadAllowedCustomerViewModel(
    readAllowedCustomerViewModel: ReadAllowedCustomerViewModel,
  ): CustomerTenantModel {
    const customerTenant = new CustomerTenantModel();
    customerTenant.code = readAllowedCustomerViewModel.code;
    customerTenant.customerGroupFlag = readAllowedCustomerViewModel.customerGroupFlag;
    customerTenant.customerGroupName = readAllowedCustomerViewModel.customerGroupName;
    customerTenant.laboratoryName = readAllowedCustomerViewModel.laboratoryName;
    customerTenant.name = readAllowedCustomerViewModel.name;
    customerTenant.uuid = readAllowedCustomerViewModel.uuid;
    return customerTenant;
  }
}
